import React from "react";
import { Link } from "react-router-dom";
import { SITE, CHAPTERS } from "../content";
import { Breadcrumbs } from "../components/Layout";
import { Reveal } from "../components/Motion";
import { GangArt } from "../components/Art";

export default function TentangPage() {
  return (
    <>
      <section className="page-head" data-testid="tentang-head">
        <Breadcrumbs current="Tentang" />
        <h1 className="page-head__title">Kedai kecil di gang yang tak pernah sepi</h1>
        <p className="page-head__lede">
          Bakmi Aboen telah berdiri di Gang Kelinci, Pasar Baru, sejak {SITE.established} — lebih
          dari enam dekade menyajikan bakmi gaya Tionghoa-Indonesia.
        </p>
      </section>

      <section className="section">
        <Reveal>
          <p className="section__eyebrow">Sejak Tahun</p>
          <div className="big-year" aria-label={`Berdiri sejak ${SITE.established}`}>
            {SITE.established}
          </div>
        </Reveal>
        <Reveal className="prose-block" delay={0.1}>
          <p style={{ marginTop: "2rem" }}>
            Tahun {SITE.established}. Pasar Baru adalah salah satu kawasan belanja tertua di Jakarta,
            dan di sebuah gang kecilnya kedai ini mulai menyalakan tungku. Tidak ada papan nama besar,
            tidak ada cabang — hanya semangkuk bakmi yang dibuat dengan cara yang sama, hari demi hari.
          </p>
          <p>
            Enam dekade kemudian, gang itu masih menjadi rumahnya. Pengunjung datang menyusuri Gang
            Kelinci sampai hampir ke ujungnya, melewati deretan toko dan kedai lain, untuk menemukan
            meja-meja sederhana yang tak pernah benar-benar sepi.
          </p>
        </Reveal>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="chapters">
          {CHAPTERS.map((c) => (
            <Reveal key={c.no} className="chapter">
              <div>
                <p className="chapter__no">{c.no}</p>
                <h2 className="chapter__title">{c.title}</h2>
              </div>
              <p className="chapter__body">{c.body}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="section band">
        <Reveal>
          <p className="section__eyebrow">Dapur Kami</p>
          <h2 className="band__address">
            Kaldu, kecap, dan topping — disiapkan setiap pagi, dijaga lintas generasi.
          </h2>
          <div className="band__meta">
            <span>Non-Halal · Mengandung Babi</span>
            <span>{SITE.hoursDisplay}</span>
          </div>
          <div className="band__ctas">
            <Link to="/menu/" className="btn btn--seal" data-testid="tentang-cta-menu">
              Lihat Menu <span className="btn__arrow">→</span>
            </Link>
          </div>
          <GangArt className="band__art" />
        </Reveal>
      </section>
    </>
  );
}
